var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrosshairTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.849,
    height: 30.849,
    viewBox: "0 0 30.849 30.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-target",
    "data-name": "Icon metro-target",
    d: "M33.419,15.424h-3.04A12.562,12.562,0,0,0,19.923,4.968V1.928H16.067v3.04A12.562,12.562,0,0,0,5.611,15.424H2.571V19.28h3.04A12.562,12.562,0,0,0,16.067,29.736v3.04h3.856v-3.04A12.562,12.562,0,0,0,30.379,19.28h3.04V15.424Zm-6.964,0H23.449A5.8,5.8,0,0,0,19.923,11.9V8.892a8.7,8.7,0,0,1,6.532,6.532Zm-8.46,3.856a1.928,1.928,0,1,1,1.928-1.928A1.928,1.928,0,0,1,17.995,19.28ZM16.067,8.892V11.9a5.8,5.8,0,0,0-3.526,3.526H9.535A8.7,8.7,0,0,1,16.067,8.892ZM9.535,19.28H12.54a5.8,5.8,0,0,0,3.526,3.526v3.005A8.7,8.7,0,0,1,9.535,19.28Zm10.388,6.532V22.807a5.8,5.8,0,0,0,3.526-3.526h3.005A8.7,8.7,0,0,1,19.923,25.812Z",
    transform: "translate(-2.57 -1.928)",
    fill: "#527991"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosshairTarget);
export default __webpack_public_path__ + "static/media/crosshairTarget.f221356c.svg";
export { ForwardRef as ReactComponent };